import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import 'leaflet/dist/leaflet.css';
// Import Vuetify styles
import 'vuetify/styles'

// Import MDI CSS
import '@mdi/font/css/materialdesignicons.css'
import VueApexCharts from 'vue3-apexcharts'

// Suppress ResizeObserver error (benign Vuetify warning)
const resizeObserverErrorHandler = (e) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.') {
    const resizeObserverErrDiv = document.getElementById('webpack-dev-server-client-overlay-div');
    const resizeObserverErr = document.getElementById('webpack-dev-server-client-overlay');
    if (resizeObserverErr) {
      resizeObserverErr.setAttribute('style', 'display: none');
    }
    if (resizeObserverErrDiv) {
      resizeObserverErrDiv.setAttribute('style', 'display: none');
    }
    return true;
  }
};

window.addEventListener('error', resizeObserverErrorHandler);

const app = createApp(App)

app.use(router)
app.use(store)
app.use(vuetify)
app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true
});
app.use(VueApexCharts)

app.mount('#app')
